module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plekan-template",
    attrs: {
      "contenteditable": "true"
    },
    domProps: {
      "innerHTML": _vm._s(_vm._content)
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bb7426a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/core/modules/plekanmodule1.vue
// module id = 109
// module chunks = 1